module.exports = __webpack_public_path__ + "static/media/reportedCampaigns.e1486330.png";